import React from 'react';
import Profile from './Profile';
import Layout from '../components/Layout';
import logo from '../assets/logo_scheduler.png';
import { getFullUrl } from '../utils/urlUtils';

export default function ProfilePage() {
  const onLogout = () => {
    localStorage.removeItem('authToken');
    window.location.href = getFullUrl('login');
  };

  return (
    <Layout
      logoSrc={logo}
      appName="Scheduler App"
      onLogout={onLogout}
    >
      <Profile />
    </Layout>
  );
} 